// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"39631fe8","983":"d4e70992"}[chunkId] + ".chunk.js";
};